export const Data = [
    {
        id: 1,
        heading: 'Loader 2',
        spinnerClass: 'loader-2'
    },
    {
        id: 2,
        heading: 'Loader 3',
        spinnerClass: 'loader-3'
    },
    {
        id: 3,
        heading: 'Loader 4',
        spinnerClass: 'loader-4'
    },
    {
        id: 4,
        heading: 'Loader 5',
        spinnerClass: 'loader-5'
    },
    {
        id: 5,
        heading: 'Loader 6',
        spinnerClass: 'loader-6'
    },
    {
        id: 6,
        heading: 'Loader 7',
        spinnerClass: 'loader-7'
    },
    {
        id: 7,
        heading: 'Loader 8',
        spinnerClass: 'loader-8'
    },
    {
        id: 8,
        heading: 'Loader 9',
        spinnerClass: 'loader-9'
    },
    {
        id: 9,
        heading: 'Loader 10',
        spinnerClass: 'loader-10'
    },
    {
        id: 10,
        heading: 'Loader 11',
        spinnerClass: 'loader-11'
    },
    {
        id: 11,
        heading: 'Loader 12',
        spinnerClass: 'loader-12'
    },
    {
        id: 12,
        heading: 'Loader 13',
        spinnerClass: 'loader-13'
    },
    {
        id: 13,
        heading: 'Loader 14',
        spinnerClass: 'loader-14'
    },
    {
        id: 14,
        heading: 'Loader 15',
        spinnerClass: 'loader-15'
    },
    {
        id: 15,
        heading: 'Loader 16',
        spinnerClass: 'loader-17'
    },
    {
        id: 16,
        heading: 'Loader 17',
        spinnerClass: 'loader-18'
    },
    {
        id: 17,
        heading: 'Loader 19',
        spinnerClass: 'loader-20'
    },
    {
        id: 18,
        heading: 'Loader 20',
        spinnerClass: 'loader-21'
    },
    {
        id: 19,
        heading: 'Loader 21',
        spinnerClass: 'loader-22'
    },
    {
        id: 20,
        heading: 'Loader 22',
        spinnerClass: 'loader-23'
    },
    {
        id: 21,
        heading: 'Loader 23',
        spinnerClass: 'loader-24'
    },
    {
        id: 22,
        heading: 'Loader 24',
        spinnerClass: 'loader-25'
    },
    {
        id: 23,
        heading: 'Loader 25',
        spinnerClass: 'loader-26'
    },
    {
        id: 24,
        heading: 'Loader 26',
        spinnerClass: 'loader-29'
    },
    {
        id: 25,
        heading: 'Loader 27',
        spinnerClass: 'loader-30'
    },
    {
        id: 26,
        heading: 'Loader 28',
        spinnerClass: 'loader-31'
    },
    {
        id: 27,
        heading: 'Loader 29',
        spinnerClass: 'loader-32'
    },
    {
        id: 28,
        heading: 'Loader 30',
        spinnerClass: 'loader-34'
    },
    {
        id: 29,
        heading: 'Loader 31',
        spinnerClass: 'loader-35'
    },
    {
        id: 30,
        heading: 'Loader 32',
        spinnerClass: 'loader-37'
    },
    {
        id: 31,
        heading: 'Loader 33',
        spinnerClass: 'loader-38'
    },
    {
        id: 32,
        heading: 'Loader 34',
        spinnerClass: 'loader-39'
    },
    {
        id: 33,
        heading: 'Loader 35',
        spinnerClass: 'loader-40'
    }
];